import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Snapshot, SnapshotMonitor, CreateSnapshotMonitorDto } from 'types';

export const createMonitor = ({
  data,
  snapshotId,
}: {
  data: CreateSnapshotMonitorDto;
  snapshotId: number;
}): Promise<SnapshotMonitor> => {
  return axios.post(`/api/snapshots/${snapshotId}/monitors`, data);
};

type UseCreateMonitorOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof createMonitor>;
};

export const useCreateMonitor = ({
  config,
  snapshotId,
}: UseCreateMonitorOptions) => {
  return useMutation({
    onMutate: async (newMonitor) => {
      await queryClient.cancelQueries(['snapshot', snapshotId]);

      const previousSnapshot = queryClient.getQueryData<Snapshot>([
        'snapshot',
        snapshotId,
      ]);

      queryClient.setQueryData(['snapshot', snapshotId], {
        ...previousSnapshot,
        monitors: [...(previousSnapshot?.monitors || []), newMonitor.data],
      });

      return previousSnapshot;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshot', snapshotId]);
    },
    ...config,
    mutationFn: createMonitor,
  });
};
